import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, Users } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden mb-[15px]" data-id="element-155">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand/20 blur-[120px] rounded-full pointer-events-none" data-id="element-156" />

      <div className="max-w-4xl mx-auto text-center relative z-10 mt-[-60px] mb-[-60px]" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full mb-8 pt-[2px] pb-[2px]" data-id="element-158">
          <span className="text-xl" data-id="element-159">🧠</span>
          <span className="font-bold tracking-widest text-gray-300 text-[12px]" data-id="element-160">
            ULTRAPACK PSICO PRO™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="md:text-5xl font-black tracking-tight mb-2 mt-[-30px] text-[22px] pt-[20px]" data-id="element-161">
          Todo tu año de Psicología.
        </motion.h1>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="md:text-5xl font-black tracking-tight mb-6 text-brand text-[36px] mt-[-20px]" data-id="element-162">
          Listo. Desde hoy
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/ksTQEuUYF3j6qjR68ffEL4/MOCKUP.png" alt="Ultrapack Psico Pro" className="max-w-2xl w-full mt-[-20px] mb-[-20px]" data-id="element-164" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mb-10 max-w-2xl mx-auto" data-id="element-165">
          <p className="text-brand mb-2 font-bold text-[18px]" data-id="element-166">
            Sin buscar más. Sin improvisar. Sin perder sesiones.
          </p>
          <p className="text-white mb-[-20px] text-[16px] font-[600] mt-[-10px]" data-id="element-167">
            Protocolos + Actividades + Hojas de Trabajo + Informes +
            Consentimientos + Gestión del Consultorio
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center gap-3 mb-[20px]" data-id="element-168">
          <div className="flex flex-wrap justify-center gap-2" data-id="element-169">
            {[{
            icon: FileText,
            text: '100% PDF'
          }, {
            icon: Zap,
            text: 'Acceso Inmediato'
          }, {
            icon: MapPin,
            text: 'Argentina'
          }].map((badge, i) => <div key={i} className="flex items-center space-x-1 bg-dark-card border border-dark-border px-2 py-1 rounded-md text-xs text-gray-300" data-id="element-170">
                <badge.icon className="w-3 h-3 text-brand" data-id="element-171" />
                <span data-id="element-172">{badge.text}</span>
              </div>)}
          </div>
          <div className="flex items-center space-x-1 bg-brand/10 border border-brand/20 px-3 py-1 rounded-full text-xs text-brand font-medium" data-id="element-173">
            <Users className="w-3 h-3" data-id="element-174" />
            <span data-id="element-175">Adultos · Adolescentes · Todos los perfiles clínicos</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-176">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand hover:bg-brand-dark text-white text-lg font-bold py-5 px-10 rounded-xl shadow-[0_0_40px_rgba(22,163,74,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(22,163,74,0.6)] flex items-center justify-center space-x-3" data-id="element-177">
            <span className="text-[17px]" data-id="element-178">
              QUIERO MI ULTRAPACK PSICO PRO AHORA
            </span>
          </button>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-400 text-xs font-medium whitespace-nowrap" data-id="element-179">
            <div className="flex items-center space-x-1" data-id="element-180">
              <span data-id="element-181">🛡️</span>
              <span data-id="element-182">Garantía 7 días</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-183">
              <span data-id="element-184">🔒</span>
              <span data-id="element-185">Pago 100% seguro</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-186">
              <span data-id="element-187">💳</span>
              <span data-id="element-188">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}